/* ============================================================
   BIOGENEZA HEADER — Dynamic Mega Menu JS
   ============================================================ */
(function () {
  'use strict';

  var header = document.querySelector('[data-bgen-header]');
  if (!header) return;

  var mobileMenu = document.querySelector('[data-bgen-mobile-menu]');
  var overlay = createOverlay();
  var activeDropdown = null;
  var activeItem = null;
  var hoverTimeout = null;

  /* ── Overlay element ── */
  function createOverlay() {
    var el = document.createElement('div');
    el.className = 'bgen-overlay';
    document.body.appendChild(el);
    el.addEventListener('click', closeAll);
    return el;
  }

  /* ============================================================
     DESKTOP DROPDOWN (mega + simple)
     ============================================================ */
  var navItems = header.querySelectorAll('[data-bgen-nav-item]');

  navItems.forEach(function (item) {
    var id = item.getAttribute('data-bgen-nav-item');
    var dropdown = document.querySelector('[data-bgen-dropdown="' + id + '"]');
    var trigger = item.querySelector('[data-bgen-nav-trigger]');
    var isMega = item.hasAttribute('data-bgen-mega');
    if (!dropdown) return;

    function positionDropdown() {
      if (isMega) {
        /* Mega: full-width, position below header */
        var rect = header.getBoundingClientRect();
        dropdown.style.top = rect.bottom + 'px';
      }
      /* Simple dropdown uses CSS absolute positioning — no JS needed */
    }

    function openDropdown() {
      clearTimeout(hoverTimeout);
      if (activeDropdown && activeDropdown !== dropdown) {
        closeDropdown();
      }
      positionDropdown();
      dropdown.classList.add('bgen-dropdown--open');
      item.classList.add('bgen-nav__item--open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (isMega) overlay.classList.add('bgen-overlay--visible');
      activeDropdown = dropdown;
      activeItem = item;
    }

    function scheduleClose() {
      hoverTimeout = setTimeout(function () {
        if (!dropdown.matches(':hover') && !item.matches(':hover')) {
          closeDropdown();
        }
      }, 120);
    }

    item.addEventListener('mouseenter', openDropdown);
    item.addEventListener('mouseleave', scheduleClose);
    dropdown.addEventListener('mouseenter', function () { clearTimeout(hoverTimeout); });
    dropdown.addEventListener('mouseleave', scheduleClose);

    /* Allow keyboard focus to open dropdown */
    if (trigger) {
      trigger.addEventListener('focus', openDropdown);
    }
  });

  function closeDropdown() {
    if (activeDropdown) {
      activeDropdown.classList.remove('bgen-dropdown--open');
    }
    overlay.classList.remove('bgen-overlay--visible');
    navItems.forEach(function (it) {
      it.classList.remove('bgen-nav__item--open');
      var trig = it.querySelector('[data-bgen-nav-trigger]');
      if (trig) trig.setAttribute('aria-expanded', 'false');
    });
    activeDropdown = null;
    activeItem = null;
  }

  function closeAll() {
    closeDropdown();
    closeMobile();
  }

  /* ============================================================
     MOBILE MENU
     ============================================================ */
  var openBtns = document.querySelectorAll('[data-bgen-open-mobile]');
  var closeBtns = document.querySelectorAll('[data-bgen-close-mobile]');

  openBtns.forEach(function (btn) { btn.addEventListener('click', openMobile); });
  closeBtns.forEach(function (btn) { btn.addEventListener('click', closeMobile); });

  function openMobile() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('bgen-mobile-menu--open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bgen-no-scroll');
  }

  function closeMobile() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('bgen-mobile-menu--open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bgen-no-scroll');
  }

  /* Mobile accordion toggles */
  var mobileToggles = document.querySelectorAll('[data-bgen-mobile-toggle]');
  mobileToggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('[data-bgen-mobile-group]');
      if (!group) return;
      var isOpen = group.classList.contains('bgen-mobile-menu__group--open');
      /* Close all others */
      document.querySelectorAll('[data-bgen-mobile-group]').forEach(function (g) {
        g.classList.remove('bgen-mobile-menu__group--open');
      });
      if (!isOpen) {
        group.classList.add('bgen-mobile-menu__group--open');
      }
    });
  });

  /* ============================================================
     ESC KEY
     ============================================================ */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* ============================================================
     SCROLL SHADOW
     ============================================================ */
  var scrollTicking = false;
  window.addEventListener('scroll', function () {
    if (!scrollTicking) {
      requestAnimationFrame(function () {
        header.classList.toggle('bgen-header--shadow', window.scrollY > 50);
        scrollTicking = false;
      });
      scrollTicking = true;
    }
  }, { passive: true });

  /* ============================================================
     CART DRAWER INTEGRATION
     ReCharge-first → native Shopify drawer → /cart fallback
     ============================================================ */

  /**
   * Próbuje otworzyć drawer koszyka ReCharge lub natywny Shopify.
   * Kolejność prób:
   *  1. window.RCACart.open / openCart   — ReCharge SDK v2/v3
   *  2. window.Recharge.openCart         — starszy wariant SDK
   *  3. DOM: ReCharge-injected toggle    — klik na element RC
   *  4. DOM: natywny cart-drawer-component (Horizon/Tinker)
   *  5. window.location.href = '/cart'   — ostateczny fallback
   */
  function openCartDrawer() {
    /* 0. ReCharge Storefront Experiences — pub/sub event */
    if (window.RechargePubSub && typeof window.RechargePubSub.publish === 'function') {
      try { window.RechargePubSub.publish('cart-drawer:open'); return; } catch (e) {}
    }

    /* 1. Rebuy SmartCart — DOM trigger (najbardziej niezawodne) */
    var rebuyTrigger = document.querySelector(
      '[data-rebuy-smart-cart-toggle], [data-rebuy-cart-toggle], ' +
      '[data-rebuy-component="smart-cart-toggle"], #rebuy-cart-toggle, ' +
      '.rebuy-cart-toggle, [data-rebuy-smart-cart] [data-rebuy-toggle]'
    );
    if (rebuyTrigger) { rebuyTrigger.click(); return; }

    /* 2. Rebuy JS API — różne warianty zależnie od wersji */
    if (window.Rebuy) {
      try {
        if (typeof window.Rebuy.importSmartCartModule === 'function' && !window.Rebuy.smart_cart) {
          window.Rebuy.importSmartCartModule();
        }
      } catch (e) {}

      var sc = window.Rebuy.smart_cart;
      if (sc && typeof sc === 'object') {
        if (typeof sc.show   === 'function') { sc.show();   return; }
        if (typeof sc.open   === 'function') { sc.open();   return; }
        if (typeof sc.toggle === 'function') { sc.toggle(); return; }
      }
      if (window.Rebuy.SmartCart) {
        var SC = window.Rebuy.SmartCart;
        if (typeof SC.show   === 'function') { SC.show();   return; }
        if (typeof SC.open   === 'function') { SC.open();   return; }
        if (typeof SC.toggle === 'function') { SC.toggle(); return; }
      }
      if (window.Rebuy.Cart) {
        var C = window.Rebuy.Cart;
        if (typeof C.show     === 'function') { C.show();     return; }
        if (typeof C.open     === 'function') { C.open();     return; }
        if (typeof C.showCart === 'function') { C.showCart(); return; }
      }
    }

    /* 3. ReCharge global API (na wypadek gdyby kiedyś doszedł do tego sklepu) */
    if (window.RCACart) {
      if (typeof window.RCACart.open === 'function')     { window.RCACart.open();     return; }
      if (typeof window.RCACart.openCart === 'function') { window.RCACart.openCart(); return; }
    }
    if (window.Recharge && typeof window.Recharge.openCart === 'function') {
      window.Recharge.openCart(); return;
    }

    /* 4. Natywny Shopify cart-drawer-component (gdyby pojawił się w DOM) */
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer) {
      var dialog = cartDrawer.querySelector('dialog');
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal(); return;
      }
      var openBtn = cartDrawer.querySelector('[on\\:click="/open"]');
      if (openBtn) { openBtn.click(); return; }
    }

    /* 5. Ostateczny fallback */
    window.location.href = '/cart';
  }

  /* Search trigger handled by inline script in biogeneza-header.liquid
     (runs before defer scripts — see section file). */

  /* Cart trigger */
  document.querySelectorAll('[data-bgen-cart-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      closeMobile();
      openCartDrawer();
    });
  });

  /* Listen for cart updates to sync badge count */
  document.addEventListener('cart:update', updateCartCount);
  document.addEventListener('CartAddEvent', updateCartCount);
  if (window.Theme && window.Theme.events) {
    document.addEventListener(window.Theme.events.cartUpdate || 'theme:cart:update', updateCartCount);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-bgen-cart-count]').forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.classList.toggle('bgen-hidden', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }

  /* ============================================================
     OPEN CART AFTER /cart REDIRECT  (open_cart=1 param)
     Works for both full page loads and SPA navigation (Tinker).
     Tries ALL cart integrations — not just ReCharge.
     ============================================================ */
  (function () {

    /* Try every cart integration except the bare /cart fallback.
       Returns true if a drawer was triggered. */
    function _tryOpenCartDrawer() {
      /* 1. ReCharge pub/sub */
      if (window.RechargePubSub && typeof window.RechargePubSub.publish === 'function') {
        try { window.RechargePubSub.publish('cart-drawer:open'); return true; } catch (e) {}
      }
      /* 2. Rebuy SmartCart — DOM toggle (most reliable) */
      var rebuy = document.querySelector(
        '[data-rebuy-smart-cart-toggle],[data-rebuy-cart-toggle],' +
        '[data-rebuy-component="smart-cart-toggle"],#rebuy-cart-toggle,.rebuy-cart-toggle'
      );
      if (rebuy) { rebuy.click(); return true; }
      /* 3. Rebuy JS API */
      if (window.Rebuy) {
        var sc = window.Rebuy.smart_cart || window.Rebuy.SmartCart;
        if (sc) {
          if (typeof sc.show   === 'function') { sc.show();   return true; }
          if (typeof sc.open   === 'function') { sc.open();   return true; }
          if (typeof sc.toggle === 'function') { sc.toggle(); return true; }
        }
        if (window.Rebuy.Cart) {
          var C = window.Rebuy.Cart;
          if (typeof C.show     === 'function') { C.show();     return true; }
          if (typeof C.open     === 'function') { C.open();     return true; }
          if (typeof C.showCart === 'function') { C.showCart(); return true; }
        }
      }
      /* 4. ReCharge global */
      if (window.RCACart) {
        if (typeof window.RCACart.open     === 'function') { window.RCACart.open();     return true; }
        if (typeof window.RCACart.openCart === 'function') { window.RCACart.openCart(); return true; }
      }
      if (window.Recharge && typeof window.Recharge.openCart === 'function') {
        window.Recharge.openCart(); return true;
      }
      /* 5. Native Shopify cart-drawer-component */
      var cd = document.querySelector('cart-drawer-component');
      if (cd) {
        var dlg = cd.querySelector('dialog');
        if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); return true; }
        var btn = cd.querySelector('[on\\:click="/open"]');
        if (btn) { btn.click(); return true; }
      }
      return false;
    }

    function _bgenOpenIfNeeded() {
      if (window.location.search.indexOf('open_cart=1') === -1) return;
      try { history.replaceState(null, '', window.location.pathname); } catch (e) {}

      /* Try immediately — if scripts already loaded this is instant */
      if (_tryOpenCartDrawer()) return;

      /* Poll every 300 ms for up to 9 s (cart apps load asynchronously) */
      var n = 0, t = setInterval(function () {
        if (_tryOpenCartDrawer() || ++n >= 30) clearInterval(t);
      }, 300);
    }

    /* Initial load (biogeneza-header.js is defer — cart apps may not be ready yet) */
    _bgenOpenIfNeeded();

    /* SPA navigation: Tinker uses Navigation API */
    if (window.navigation) {
      window.navigation.addEventListener('navigate', function (e) {
        try {
          var dest = new URL(e.destination.url);

          /* ── SPA navigation to /cart → force a clean full-page reload
             to /?open_cart=1, which triggers _bgenOpenIfNeeded above.
             SKIP form submissions (e.formData != null) — Recharge's
             "Dalej" submits POST /cart with checkout=1, which Shopify
             then 302-redirects to /checkouts/... and we must not break
             that flow. SKIP traverse navigation (back/forward) too. ── */
          if (dest.pathname === '/cart'
              && dest.search.indexOf('open_cart=1') === -1
              && !e.formData
              && e.navigationType !== 'traverse') {
            if (typeof e.intercept === 'function') {
              e.intercept({ handler: function () {
                window.location.replace('/?open_cart=1');
                return new Promise(function () { /* never resolve, page is leaving */ });
              }});
            } else {
              window.location.replace('/?open_cart=1');
            }
            return;
          }

          /* ── Handle open_cart=1 param (full-page redirect lands here) ── */
          if (dest.search.indexOf('open_cart=1') !== -1) {
            setTimeout(_bgenOpenIfNeeded, 50);
          }
        } catch (_) {}
      });
    }
  }());
})();
